module.exports = __webpack_public_path__ + "img/jilin.6853ef80.jpg";